import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import Loader2 from "../../Components/Loader2";
import { language } from "../../language/Language";
import { useGetBrandsQuery } from "../../RTK/Slices/Slices/apiSliceMeat";
import Brand from "../../assets/b.png";

// placeholder عند غياب الصورة
const PlaceholderBrand = ({ name }) => (
    <div
        style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg,#f9f0ec,#f0e8e2)",
            borderRadius: 10,
            padding: "8px 6px",
        }}
    >
        <p
            style={{
                fontSize: 13,
                fontWeight: 800,
                color: "#c0392b",
                textAlign: "center",
                lineHeight: 1.3,
                wordBreak: "break-word",
                fontFamily: "Cairo, sans-serif",
            }}
        >
            {name}
        </p>
    </div>
);

function BrandsSections() {
    const { data: Brands, isError, isLoading } = useGetBrandsQuery();
    const dataBrands = Brands?.data ?? [];

    if (isLoading) return <Loader2 />;
    if (isError)   return null; // fail silently
    if (dataBrands.length === 0) return null;

    return (
        <div className="bg-gray-100">
            {/* العنوان */}
            <div className="flex items-center justify-center w-full !pt-5 md:!pt-10 container">
                <img className="w-14 ml-2" src={Brand} alt="Brands" />
                <h1 className="text-mainColor text-lg font-bold md:text-4xl">
                    {language === "ar" ? "تسوق حسب الماركة" : "Shop by Brand"}
                </h1>
            </div>

            {/* السلايدر */}
            <div className="container">
                <Swiper
                    key={dataBrands.length}
                    rewind
                    navigation
                    spaceBetween={10}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    modules={[Autoplay, Navigation]}
                    className="mySwiper !py-5 md:!py-10"
                    breakpoints={{
                        1320: { slidesPerView: 6, spaceBetween: 10 },
                        1140: { slidesPerView: 5, spaceBetween: 10 },
                        768:  { slidesPerView: 4, spaceBetween: 10 },
                        640:  { slidesPerView: 3.5, spaceBetween: 10 },
                        0:    { slidesPerView: 2.5, spaceBetween: 10 },
                    }}
                >
                    {dataBrands.map((item) => (
                        <SwiperSlide
                            key={item?.brand_id}
                            className="bg-white rounded-2xl hover:!-translate-y-1 !transition-all"
                        >
                            <Link
                                to={`/ProductsBrand/${item?.brand_id}`}
                                className="block rounded-2xl p-3 cursor-pointer"
                            >
                                {/* صورة البراند (دائرية) */}
                                <div
                                    style={{
                                        width: "100%",
                                        height: 90,
                                        margin: "0 auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        overflow: "hidden",
                                        borderRadius: 10,
                                        marginBottom: 8,
                                        background: "#fafafa",
                                        border: "1px solid #eee",
                                    }}
                                >
                                    {item?.image_url ? (
                                        <img
                                            src={item.image_url}
                                            alt={item?.brand_name}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                            onError={(e) => {
                                                e.currentTarget.style.display = "none";
                                                const p = e.currentTarget.parentElement;
                                                if (p) p.innerHTML = `<p style="font-size:13px;font-weight:800;color:#c0392b;text-align:center;font-family:Cairo,sans-serif;">${item?.brand_name ?? ""}</p>`;
                                            }}
                                        />
                                    ) : (
                                        <PlaceholderBrand name={item?.brand_name ?? ""} />
                                    )}
                                </div>

                                {/* اسم البراند */}
                                <p
                                    style={{
                                        textAlign: "center",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: "#333",
                                        fontFamily: "Cairo, sans-serif",
                                        lineHeight: 1.3,
                                        overflow: "hidden",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                    }}
                                >
                                    {item?.brand_name}
                                </p>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default BrandsSections;
